
angular.module('bmsApp.crm.enquiry', [
	'ui.router'
])
	.config([
		'$stateProvider', 'BMSPermission', function config(
			$stateProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.crm.enquiry', {
					abstract: true,
					data: {
						authorisedRoles: [BMSPermission.CRM]
					}
				})
				
				.state('main.crm.enquiry.index', {
					url: '/enquiries',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/enquiry/templates/EnquiryIndex.html",
							controller: 'EnquiryIndexCtrl'
						},
						'side@main.crm': {
							templateUrl: "ng/crm/enquiry/templates/EnquiryIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Enquiries'}
				})
				
				.state('main.crm.enquiry.index.view', {
					url: '^/crm/enquiry/{enquiryId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/enquiry/templates/EnquiryView.html",
							controller: 'EnquiryViewCtrl'
						}
					},
					ncyBreadcrumb: {label: '{{ enquiry.display_name }}'}
				})

				.state('main.crm.enquiry.index.create', {
					url: '^/crm/enquiry/add',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/enquiry/templates/EnquirySave.html",
							controller: 'EnquirySaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add Enquiry'}
				})

				.state('main.crm.enquiry.index.view.update', {
					url: '^/crm/enquiry/edit/{enquiryId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/enquiry/templates/EnquirySave.html",
							controller: 'EnquirySaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit Enquiry'}
				})



				;
				
		}]);
